/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Calendar_Quota_Exhausted_MonthInputs */

const fr_calendar_quota_exhausted_month = /** @type {(inputs: Calendar_Quota_Exhausted_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tous tes cours de ${i?.month} sont utilisés`)
};

/**

* @param {Calendar_Quota_Exhausted_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_exhausted_month = /** @type {((inputs: Calendar_Quota_Exhausted_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Exhausted_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_exhausted_month(inputs)
});